import type { BookingType } from '@shared/transactions-types';

import type { TransactionPredicate } from './types';

export const isBookingType =
    (...bookingTypes: BookingType[]): TransactionPredicate =>
    ({ bookingType }) =>
        Boolean(bookingType) && bookingTypes.includes(bookingType);
